import React from 'react';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  BreadcrumbsSlice as BreadcrumbSliceProps,
  Breadcrumb as BreadcrumbSliceType,
} from '../../../../types';

type BreadcrumbType = BreadcrumbSliceType & {
  id: string;
  pathName: string;
};

const BreadcrumbSlice = ({ items }: BreadcrumbSliceProps) => {
  const { t } = React.useContext(AppContext);

  return (
    <Breadcrumb
      homeText={t('common', 'breadcrumb.home')}
      path={
        items
          .map(item =>
            item?.pathName
              ? {
                  ...item,
                  id: item.pathName,
                }
              : undefined
          )
          .filter(x => x) as BreadcrumbType[]
      }
    />
  );
};

export default BreadcrumbSlice;
